<template>
  <div v-if="isBonusViewAllowed" class="container invoice-table">
    <br>
    <h5>Бонус</h5>
    <div class="container">
      <div class="row">
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 100px">
            <select v-model="year"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Год"
                    aria-describedby="basic-addon2">
              <option v-for="item in years" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto">
          <div class="input-group mb-3" style="max-width: 100px">
            <select v-model="month"
                    @change="switchCountry"
                    class="form-control"
                    aria-label="Месяц"
                    aria-describedby="basic-addon2">
              <option v-for="item in months" :value="item">{{ item }}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-auto text-left">
          Подготовлено: {{ new Intl.NumberFormat('ru-ru').format(Math.round(this.sum_prepared)) }} <br>
          Согласовано: {{ new Intl.NumberFormat('ru-ru').format(Math.round(this.sum_approved)) }} <br>
          Выплачено: {{ new Intl.NumberFormat('ru-ru').format(Math.round(this.sum_already_paid)) }}
        </div>

        <button
            class="btn my-2 my-sm-0 float-right m-1" style="width: 150px"
            v-if="isActionsEnabled"
            v-bind:class="isLoadError ? 'btn-outline-danger' : 'btn-outline-primary'"
            @click="loadBonuses">
          <!--            :disabled="isReloadDisabled || editInvoice || isBlocked || isCreateDisabled">-->
          <!--            <span v-if="!isReloadDisabled">-->
          <span>Загрузить</span>
          <!--            </span>-->
          <span v-if="isLoadDisabled" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
            </span>
        </button>
        <button
            class="btn my-2 my-sm-0 right m-1" style="width: 150px"
            v-if="isActionsEnabled"
            v-bind:class="isSendError ? 'btn-outline-danger' : 'btn-outline-primary'"
            @click="sendBonuses">
          <!--            :disabled="isReloadDisabled || editInvoice || isBlocked || isCreateDisabled">-->
          <!--            <span v-if="!isReloadDisabled">-->
          <span>Отправить</span>
          <!--            </span>-->
          <span v-if="isSendDisabled" class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
            </span>
        </button>

      </div>
    </div>

    <p v-if="message" class="float-left text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </p>

    <div>
      <table class="table table-sm text-left">
        <thead>
        <th class="text-left invoice-table-td-small">ID</th>
        <th class="text-left invoice-table-td-medium">Команда</th>
        <th class="text-left invoice-table-td-small">Тип</th>
        <th class="left invoice-table-td-medium">Сотрудник</th>
        <th class="text-right invoice-table-td-small">Бонус</th>
        <th class="text-right invoice-table-td-small">+ Дежурства</th>
        <th class="text-right invoice-table-td-small">+ Корректировка</th>
        <th class="text-right invoice-table-td-small">= Итого</th>
        <th class="text-center invoice-table-td-small">Согласован</th>
        </thead>
        <tbody>
        <template v-for="(m, m_idx) in bonuses">
          <tr>
            <td class="text-left text-nowrap">{{ m.id }}</td>
            <td class="text-left text-nowrap">{{ m.team.name }}</td>
            <td class="text-left text-nowrap">{{ m.premium_type }} - {{ m.event }}</td>
            <td class="text-left text-nowrap">{{ m.user_account.display_name }}</td>
            <td class="text-right text-nowrap"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_premium))
              }}
            </td>
            <td class="text-right">
              <div v-if="m.editableDuty && m.active">
                <input v-model.number="m.sum_duty"
                       @change="saveBonusDuty(m_idx)"
                       @blur="saveBonusDuty(m_idx)"
                       type="number" class="text-right table-td-input no-spin"/>
              </div>
              <div v-else @click="m.editableDuty = true" v-bind:class="{ 'cursor-pointer': m.active }">
                {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(m.sum_duty))
                }}
              </div>
            </td>
            <td class="text-right">
              <div v-if="m.editableCorrection && m.active && isAdmin">
                <input v-model.number="m.sum_correction"
                       @change="saveBonusCorrection(m_idx)"
                       @blur="saveBonusCorrection(m_idx)"
                       type="number" class="text-right table-td-input no-spin"/>
              </div>
              <div v-else @click="m.editableCorrection = true" v-bind:class="{ 'cursor-pointer': m.active }">
                {{
                  new
                  Intl.NumberFormat('ru-ru').format(Math.round(m.sum_correction))
                }}
              </div>
            </td>
            <td class="text-right font-weight-bold"> {{
                new
                Intl.NumberFormat('ru-ru').format(Math.round(m.sum_total))
              }}
            </td>
            <td class="text-center">
              <div v-if="isAdmin && isActive && m.status != 3 ">
                <input v-model.number="m.approved"
                       @change="saveBonusApprove(m_idx)"
                       type="checkbox" class="text-right table-td-input no-spin"/>
              </div>
              <div v-else>
                {{
                  m.approved ? (m.status == 3 ? "выплачен" : "да") : "нет"
                }}
              </div>
            </td>
          </tr>
        </template>
        <tr>
          <td class="text-left"></td>
          <td class="text-left"></td>
          <td class="text-left"></td>
          <td class="text-left"></td>
          <td class="text-right font-weight-bold">{{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.total_sum_premium))
            }}
          </td>
          <td class="text-right font-weight-bold"> {{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.total_sum_duty))
            }}
          </td>
          <td class="text-right font-weight-bold"> {{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.total_sum_correction))
            }}
          </td>
          <td class="text-right font-weight-bold"> {{
              new
              Intl.NumberFormat('ru-ru').format(Math.round(this.total_sum_total))
            }}
          </td>
          <td class="text-right font-weight-bold">
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>

<script>
import axios from 'axios';

let d = new Date();

let this_year = d.getFullYear();
let this_month = d.getMonth();

this_month = this_month + 1;


export default {
  name: 'BonusList',
  data() {
    return {
      years: [2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      year: this_year,
      month: this_month,
      isActionsEnabled: false,
      isLoadError: false,
      isLoadDisabled: false,
      isSendError: false,
      isSendDisabled: false,
      isAdmin: false,
      isActive: true,
      bonuses: [],
      message: '',
    }
  },

  computed: {
    isBonusViewAllowed() {
      return this.$store.getters.isBonusViewAllowed
    },
    isCurrentMonth: function () {
      return this.year == this_year && this.month == this_month
    },
    total_sum_premium: function () {
      return this.bonuses ? this.bonuses.map(el => el.sum_premium).reduce((a, b) => a + b, 0) : 0;
    },
    total_sum_duty: function () {
      return this.bonuses ? this.bonuses.map(el => el.sum_duty).reduce((a, b) => a + b, 0) : 0;
    },
    total_sum_correction: function () {
      return this.bonuses ? this.bonuses.map(el => el.sum_correction).reduce((a, b) => a + b, 0) : 0;
    },
    total_sum_total: function () {
      return this.bonuses ? this.bonuses.map(el => el.sum_total).reduce((a, b) => a + b, 0) : 0;
    },
    sum_prepared: function () {
      return this.bonuses ? this.bonuses.filter(function (el) {
        return el.status === 1;
      }).map(el => el.sum_total).reduce((a, b) => a + b, 0) : 0;
    },
    sum_approved: function () {
      return this.bonuses ? this.bonuses.filter(function (el) {
        return el.status === 2;
      }).map(el => el.sum_total).reduce((a, b) => a + b, 0) : 0;
    },
    sum_already_paid: function () {
      return this.bonuses ? this.bonuses.filter(function (el) {
        return el.status === 3;
      }).map(el => el.sum_total).reduce((a, b) => a + b, 0) : 0;
    },
  },

  methods: {
    search() {
      axios.get('/bonuses', {
        params: {
          year: this.year,
          month: this.month,
        },
      })
          .then((res) => {
            // console.log(res.data);

            res.data.forEach(function (element) {
              element.editableDuty = false;
              element.editableCorrection = false;
              element.active = false;
              element.approved = true;

              if (element.status == 1) {
                element.active = true;
                element.approved = false;
              }

              element.items = [];
            });

            this.bonuses = res.data;

            this.checkIsActive();

          })
          .catch(error => {
            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    },

    loadBonuses() {
      this.isLoadDisabled = true;
      this.isLoadError = false;

      axios.get('/load_bonuses', {
        params: {
          year: this.year,
          month: this.month,
        },
      })
          .catch(error => {
            console.log(`Error: ${error}`)
            this.isLoadError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isLoadDisabled = false;
          });
    },

    sendBonuses() {

      this.isSendDisabled = true;
      this.isSendError = false;
      this.message = '';

      axios.get('/send_bonuses')
          .then((res) => {
            // console.log(res.data);

          })
          .catch(error => {
            console.log(`Error: ${error}`)
            this.isSendError = true;
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          })
          .finally(() => {
            this.isSendDisabled = false;
          });
    },


    switchCountry() {
      localStorage.setItem('year', this.year);
      localStorage.setItem('month', this.month);

      this.search();
    },

    saveBonusDuty(idx) {
      this.bonuses[idx].editableDuty = false;
      this.bonuses[idx].sum_total = this.bonuses[idx].sum_premium + this.bonuses[idx].sum_duty + this.bonuses[idx].sum_correction;

      this.saveBonus(this.bonuses[idx]);
    },


    saveBonusCorrection(idx) {
      this.bonuses[idx].editableCorrection = false;
      this.bonuses[idx].sum_total = this.bonuses[idx].sum_premium + this.bonuses[idx].sum_duty + this.bonuses[idx].sum_correction;

      this.saveBonus(this.bonuses[idx]);
    },

    saveBonusApprove(idx) {

      if (this.bonuses[idx].approved === true) {
        this.bonuses[idx].status = 2;
        this.bonuses[idx].active = false;
      }

      if (this.bonuses[idx].approved === false) {
        this.bonuses[idx].status = 1;
        this.bonuses[idx].active = true;
      }

      this.saveBonus(this.bonuses[idx]);
    },

    checkIsActive() {
      let limitMonth = this_month - 1;
      let limitYear = this_year;
      if (limitMonth == 0) {
        limitMonth = 12
        limitYear = limitYear - 1
      }

      // console.log(limitMonth);
      // console.log(limitYear);

      let limitDate = new Date(limitYear, limitMonth - 1, 1);
      let premiumDate = new Date(this.year, this.month - 1, 1);

      // console.log(limitDate);
      // console.log(premiumDate);
      // console.log(premiumDate < limitDate);

      this.isActive = premiumDate >= limitDate;
    },

    saveBonus(b) {
      axios.post('/bonus_save', b)
          .then((res) => {
            // console.log(res.data);

            // res.data.forEach(function (element) {
            //     element.show_children = false;
            //     element.items = [];
            // });
            //
            // this.planManager[m_idx].items[customer_idx].items = res.data;

          })
          .catch(error => {
            b.status = 1;
            b.approved = false;

            console.log(error);
            this.message = (typeof error.response !== 'undefined') ? error.response.data : error.message;
          });
    }

  },


  beforeCreate() {
    axios.defaults.headers.authorization = this.$store.state.token;
  }
  ,

  created() {

    document.title = 'Бонус';

    let d = new Date();

    let year = localStorage.getItem('year');

    if (year != null) {
      this.year = year
    } else {
      this.year = d.getFullYear();
      localStorage.setItem('year', this.year);
    }

    let month = localStorage.getItem('month');

    if (month != null) {
      this.month = month
    } else {
      this.month = d.getMonth() + 1;
      localStorage.setItem('month', this.month);
    }

    const userId = localStorage.getItem('userId');
    if (userId && (userId == 10 || userId == 20 || userId == 56)) {
      this.isAdmin = true;
    }

    if (userId && (userId == 10)) {
      this.isActionsEnabled = true;
    }

    // this.checkIsActive();
    this.search();
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.invoice-table {
  font-size: 14px;
}

.invoice-table-td-medium {
  width: 110px;
}

.invoice-table-td-small {
  width: 50px;
}

.table-td-input {
  width: 50px;
}

.invoice-table-tr-height {
  vertical-align: middle;
  height: 36px;
}

.vertical-align-middle {
  vertical-align: middle;
}

.manager-td-width {
  width: 130px;
}

.td-padding-left-1 {
  padding-left: 40px;
}

.td-padding-left-2 {
  padding-left: 80px;
}

.td-padding-left-3 {
  padding-left: 120px;
}

.td-padding-left-4 {
  padding-left: 160px;
}

.no-spin::-webkit-inner-spin-button, .no-spin::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
  -moz-appearance: textfield !important;
}

</style>
